/** Shared debit card design ids, validation, and defaults for client and server. */

export const DEBIT_CARD_DESIGN_IDS = [
  'clownfish',
  'frog',
  'macaw',
  'monarch',
  'triggerfish',
  'jellyfish',
  'blue',
  'black',
] as const

export type DebitCardDesignId = typeof DEBIT_CARD_DESIGN_IDS[number]

export const DEFAULT_DEBIT_CARD_DESIGN_ID: DebitCardDesignId = DEBIT_CARD_DESIGN_IDS[0]

export const DEBIT_CARD_DESIGN_LABELS: Record<DebitCardDesignId, string> = {
  clownfish: 'Orange Fish',
  frog: 'Frog',
  macaw: 'Parrot',
  monarch: 'Butterfly',
  triggerfish: 'Blue Fish',
  jellyfish: 'Caterpillar',
  blue: 'Blue',
  black: 'Black',
}

export const DEBIT_CARD_DESIGN_OPTIONS = DEBIT_CARD_DESIGN_IDS.map((id) => ({
  label: DEBIT_CARD_DESIGN_LABELS[id],
  value: id,
}))

export function isDebitCardDesignId(value: unknown): value is DebitCardDesignId {
  return typeof value === 'string' && DEBIT_CARD_DESIGN_IDS.includes(value as DebitCardDesignId)
}

export function debitCardDesignIdOrDefault(value: unknown): DebitCardDesignId {
  return isDebitCardDesignId(value) ? value : DEFAULT_DEBIT_CARD_DESIGN_ID
}

export function buildDebitCardDesignMap(
  recipients: string[],
  existing: Record<string, unknown> = {},
): Record<string, DebitCardDesignId> {
  return recipients.reduce<Record<string, DebitCardDesignId>>((next, recipient) => {
    next[recipient] = debitCardDesignIdOrDefault(existing[recipient])
    return next
  }, {})
}

export function getDebitCardDesignLabel(value?: string): string {
  return isDebitCardDesignId(value) ? DEBIT_CARD_DESIGN_LABELS[value] : value || 'Not selected'
}
